const UNROCACountryNames = {
  'bolivia-plurinational-state-of': 'bolivia',
  'cabo-verde': 'cape-verde',
  'cte-divoire': 'cote-divoire',
  'iran-islamic-republic-of': 'islamic-republic-of-iran',
  'micronesia-federated-states-of': 'federated-states-of-micronesia',
  'united-kingdom-of-great-britain-and-northern-ireland': 'united-kingdom',
  'united-states-of-america': 'united-states',
  'venezuela-bolivarian-republic-of': 'bolivarian-republic-of-venezuela'
};

export default UNROCACountryNames;



// WEBPACK FOOTER //
// ./src/helpers/UNROCACountryNames.js